import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import styles from "./IndividuDetall.module.css";
import { getIdIndividuLlista, getDadesOriginalsIndividu } from "../../reducers";
import IndividuFormulari from "./IndividuFormulari";
import * as rutes from "../../routes";
import { obtenirDadesIndividu } from "../../actions";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import { MISSATGE_SPIN_INDRET } from "../../constantsFormularis";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { rutaIndividus, rutaEdicioIndividu } from "../../routes";

class IndividuDetall extends Component {
  componentDidMount() {
    const { idIndividu } = this.props;
    this.props.obtenirDadesIndividu(idIndividu);
  }

  generarBotoDonarDeBaixa() {
    return (
      <Link
        to={{
          pathname: rutes.rutaBaixaIndividu,
          query: { render: false }
        }}
      >
        <Button size="large">Donar de baixa</Button>
      </Link>
    );
  }

  generarBotoEditar() {
    return (
      <Link
        to={{
          pathname: rutaEdicioIndividu,
          query: { render: false }
        }}
      >
        <Button type="primary" size="large">
          Editar
        </Button>
      </Link>
    );
  }

  generarBotoTornar() {
    return (
      <Link
        className={styles.back}
        to={{
          pathname: rutaIndividus,
          query: { render: false }
        }}
      >
        <Button icon="left">Tornar</Button>
      </Link>
    );
  }

  render() {
    const { dadesOriginals } = this.props;

    if (!dadesOriginals || !dadesOriginals.id) {
      return (
        <Spin
          spinning={true}
          delay={RETARD_MILISEGONS_APARICIO_SPINNER}
          tip={MISSATGE_SPIN_INDRET}
        />
      );
    }

    const estat = dadesOriginals && dadesOriginals.dataBaixa ? false : true;
    const botoBaixaIndividu = estat ? this.generarBotoDonarDeBaixa() : null;
    const botoEditar = this.generarBotoEditar();
    const botoTornar = this.generarBotoTornar();

    return (
      <div className={styles.individuIntroduccioDetall}>
        <div className={styles.individuIntroduccioDetallContenidor}>
          <IndividuFormulari esEditable={false} />
        </div>
        <div className={styles.individuIntroduccioDetallBotons}>
          {botoEditar}
          {botoBaixaIndividu}
        </div>
        <div className={styles.individuBotoTornar}>{botoTornar}</div>
      </div>
    );
  }
}

IndividuDetall.propTypes = {
  idIndividu: PropTypes.number,
  obtenirDadesIndividu: PropTypes.func.isRequired,
  dadesOriginals: PropTypes.object
};

const mapStateToProps = state => {
  return {
    idIndividu: getIdIndividuLlista(state),
    dadesOriginals: getDadesOriginalsIndividu(state)
  };
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, { obtenirDadesIndividu })(IndividuDetall)
);
